import { jsx as a } from "react/jsx-runtime";
import { s as o } from "../../Player.module-DcPK3CRl.js";
import { c as i } from "../../index-BkL7vJ-E.js";
const s = ({ children: r }) => /* @__PURE__ */ a("div", { className: i(o.loadingContainer, "hamrah-player__loading"), children: r ?? "درحال بارگذاری ویدئو ..." });
export {
  s as default
};
